import React, {useEffect, useState} from 'react';
import './App.css';
import MainContainer from './Components/Shared/MainContainer';
import {ToastProvider} from 'react-native-toast-notifications';
import {TemplateConversionProvider} from './Providers/TemplateConversionProvider';
import Colors from './Styles/Shared/Colors';
import {PermissionProvider} from './Providers/PermissionProvider';
import {SubmissionRelationProvider} from './Providers/SubmissionRelationProvider';
import {WriteStatusProvider} from './Providers/WriteStatusProvider';
import {MessageProvider} from './Providers/MessagesProvider';

type AppProps = {
  logoutCallback: () => Promise<void>;
};

const App = (props: AppProps): React.ReactElement => {
  return (
    <PermissionProvider>
      <SubmissionRelationProvider>
        <TemplateConversionProvider>
          <MessageProvider>
            <WriteStatusProvider>
              <ToastProvider successColor={Colors.teal}>
                <MainContainer
                  navigation={null}
                  logoutCallback={props.logoutCallback}
                />
              </ToastProvider>
            </WriteStatusProvider>
          </MessageProvider>
        </TemplateConversionProvider>
      </SubmissionRelationProvider>
    </PermissionProvider>
  );
};

export default App;
